


import { Link } from "react-router-dom"
import { AppSettingsVar } from "../../../_project/settings"
import ModalFormContext from '../../../store/ModalFormContext';
import { useContext } from "react";


const FormPageButton = (props) =>{
    const page_url = AppSettingsVar.portal_prefix + props.url.replace('/rest/', 'form/')
    const modalFormContext = useContext(ModalFormContext);

    const setForm = () => {
        var url = props.url
        if(props.alter_url_func){
            url = props.alter_url_func(url)
        }
        modalFormContext.callbackFunc = props.callbackFunc
        modalFormContext.setModalForm({...props, url:url});
        
    }

    return <Link to={page_url} className={`${props.className} action-button`}>
            {props.children}
    </Link>

}

export default FormPageButton;